const QR_CODE_CLIENT_URL = window.location.origin === 'https://tos.thirky.com'
  ? 'https://qrcoud.com'
  : 'http://localhost:3000';

export default QR_CODE_CLIENT_URL;
